window.addEventListener('load', function () {
  var email = document.cookie.replace(/(?:(?:^|.*;\s*)gaThankYouEmail\s*\=\s*([^;]*).*$)|^.*$/, '$1');
  var visitorId = document.cookie.replace(/(?:(?:^|.*;\s*)visitorId\s*\=\s*([^;]*).*$)|^.*$/, '$1');

  if ((visitorId === '' || visitorId === 'undefined') && email && window.gaSetUserId) {
    window.gaSetUserId(email);
  }
});
